import { createApp } from "vue";
import Search from "./Search.vue";
// import store from "./store/store"; // Uncomment if you use Vuex store

if (document.querySelector('.search-container')) {
  const app = createApp(Search);
  // app.use(store); // Uncomment if you use Vuex store
  app.mount('.search-container');
}
